import { FC } from 'react';

import { BookmarkIconButton } from '@bonusly/common-bookmark';
import { RelativeTime } from '@bonusly/common-relative-time';
import { HStack, rem, Spacer, useBreakpointValue } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import { Reveal } from '../../../../display/reveal';
import { BonusOptionsMenu, BonusOptionsMenuProps } from '../../components/bonus/bonus-options-menu';
import { Chip } from '../../components/common/chip';
import { UserAvatarGroup } from '../../components/user-avatar';
import { BonusFeedTrackedAction, useTrackBonusFeedItemEvent } from '../../hooks/use-bonus-feed-item-analytics';
import { BonusUnlinkButton } from './bonus-unlink-button';

export type BonusHeaderProps = BonusOptionsMenuProps & {
	displayOptionsMenu?: boolean;
	displayAmount?: boolean;
	onClickUnlinkBonus?: VoidFunction;
	sectionTitle?: string;
};

export const BonusHeader: FC<BonusHeaderProps> = ({
	bonus,
	displayOptionsMenu = true,
	displayAmount = true,
	hideBookmarkButton,
	onClickUnlinkBonus,
	sectionTitle,
	...rest
}) => {
	const max = useBreakpointValue({ base: 1, sm: 5 });
	const company = useCurrentCompany();
	const trackAvatarClick = useTrackBonusFeedItemEvent(bonus, BonusFeedTrackedAction.AvatarClick);

	const showAmount = displayAmount && company?.show_bonus_amounts && !!bonus.family_amount;

	return (
		<HStack alignItems="center" spacing={2}>
			<Reveal if={showAmount}>
				<Chip size="sm" variant="amount" height="auto">
					+{bonus.family_amount}
				</Chip>
			</Reveal>

			<UserAvatarGroup
				max={max}
				users={bonus.receivers}
				recipients={bonus.recipients}
				onAvatarClick={() => {
					trackAvatarClick();
				}}
				zIndex={1}
			/>

			<Spacer />

			<RelativeTime color="text.soft" date={new Date(bonus.created_at)} />

			{onClickUnlinkBonus && sectionTitle && <BonusUnlinkButton onClickUnlinkBonus={onClickUnlinkBonus} sectionTitle={sectionTitle} />}

			{!hideBookmarkButton && <BookmarkIconButton />}

			{displayOptionsMenu && <BonusOptionsMenu bonus={bonus} boxSize={rem(40)} {...rest} />}
		</HStack>
	);
};
